import { FC } from 'react';
import ManagerAssistGreyscale from '@assets/atlas-icon-greyscale.svg';
import ManagerAssist from '@assets/atlas-icon.svg';
import { IconProps } from '@servicetitan/design-system';
import classNames from 'classnames';
import styles from './ManagerAssistIcon.module.css';

interface ManagerAssistIconProps extends Omit<IconProps, 'name'> {
  isActive: boolean;
}

export const ManagerAssistIcon: FC<ManagerAssistIconProps> = (
  props: ManagerAssistIconProps,
) => (
  <div
    className={classNames(
      'd-f justify-content-left align-items-center',
      styles.managerAssistIconBlock,
    )}
  >
    {props.isActive && <ManagerAssist data-cy='managerAssistIconActive' />}
    {!props.isActive && (
      <ManagerAssistGreyscale data-cy='managerAssistIconInactive' />
    )}
  </div>
);
